import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import './AdminEditUser.css';

const API_URL = process.env.REACT_APP_API_URL + "/users";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const[user, setUser] = useState(null);
  const[form, setForm] = useState({ name: '', lastname: '', email: '', country: '', city: '', phone: '', subscriptionLevel: '', password: '' });
  const[loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`}
    })
    .then(res => res.json())
    .then(data => {
      setUser(data);
      setForm({
        name: data.name,
        lastname: data.lastname,
        email: data.email,
        subscriptionLevel: data.subscriptionLevel,
        country: data.country,
        city: data.city,
        phone: data.phone
      });
      setLoading(false)
    });
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure? After deletion user details will be lost completely")) return;
      try {
        const res = await fetch(`${API_URL}/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
      if (!res.ok) {
        const errorData = await res.json();
        alert(errorData.error || "Failed to delete user.");
        return;
      }
      alert("User deleted successfully!");
      navigate('/admin');
    } catch (err) {
      alert("An error occured!");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(`${API_URL}/${id}/admin-update`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(form)

    })
    .then(res => {
      if (!res.ok) throw new Error("Failed to update user");
      return res.json();
    })
    .then(data => {
      alert("User Details has been updated!");
      navigate('/admin');
    })
    .catch(err => {
      console.error(err);
      alert("Failed to update user. Check console.");
    });
  };

  if (loading) return <div>Loading ... </div>
  if (!user) return <div> User not found</div>  

  return (
    <div className="edit-userform">
      <h2 style={{fontFamily: "regular-futura", fontWeight: "400"}}>Edit User Details of : " {user.email} "</h2>
      <form onSubmit={handleSubmit}>
        <div><p>Name</p>
          <input name="name" value={form.name} onChange={handleChange} placeholder="First Name"/>
        </div>
        <div><p>Last Name</p>
          <input name="lastname" value={form.lastname} onChange={handleChange} placeholder="Last Name"/>
        </div>
        <div><p>E-mail</p>
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="E-mail"/>
        </div>
        <div><p>Country</p>
          <input name="country" value={form.country} onChange={handleChange} placeholder="Country" />
        </div>
        <div><p>City</p>
          <input name="city" value={form.city} onChange={handleChange} placeholder="City" />
        </div>
        <div><p>Phone</p>
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
        </div>
        <div><p>Subscription Level</p>
          <input name="subscriptionLevel" value={form.subscriptionLevel} onChange={handleChange} placeholder="Subscription Level" />
        </div>
        <div><p>Password</p>
          <input name="password" value={form.password} onChange={handleChange} placeholder="Change Password of the User**" />
        </div>
        <button type="submit">Save Changes</button>  {/* buradan admin get users a donsin  */}
        <button type="button" onClick={handleDelete} style={{ background: 'red', color: 'white'}}>Delete User</button>
      </form>
    </div>
  )

}
export default EditUser;